export default __webpack_public_path__ + "static/media/speech.bcb861e9.webp";